<template>
    <div id="app-layout" :class="{ 'detail success': true, 'is-edit': $route.meta.isAddView }" v-cloak>
        <div class="main-container">
            <div :class="{ 'main-nav': true }">
                <div
                    v-if="event_loaded"
                    :class="{
                        container: true,
                        'events-list': false,
                        detail: true
                    }"
                >
                    <div v-if="delete_modal_shown">
                        <event-delete-modal
                            :show_delete_all="show_all"
                            :event="event"
                            :shown="true"
                            @close-modal="hide_delete_modal"
                        ></event-delete-modal>
                    </div>

                    <main-navigation-header></main-navigation-header>

                    <trial-over
                        @close-modal="hide_trial_modal"
                        v-if="trial_modal_shown"
                        :shown="trial_modal_shown"
                    ></trial-over>

                    <div class="main-nav-title">
                        <a @click="go_back" href="javascript:{}" class="main-nav-back">
                            <span class="icon-arrow-left"></span>
                        </a>
                        <div class="main-nav-left" v-if="$route.name !== 'event-guests-add'">
                            {{ event.name }}
                            <p>
                                {{ moment(event.event_time).format("dd")[0] }}
                                {{ moment(event.event_time).format("DD.MM, HH:mm") }}
                                <span v-if="event.location">@ {{ event.location }}</span>
                            </p>
                        </div>
                        <div class="main-nav-left" v-else>
                            Add guests
                            <p>
                                {{ event.name }}, {{ moment(event.event_time).format("dd")[0] }}
                                {{ moment(event.event_time).format("DD.MM, HH:mm") }}
                                <span v-if="event.location">@ {{ event.location }}</span>
                            </p>
                        </div>
                        <a
                            v-if="$route.meta.isAddView && $route.name === 'event-tasks-add'"
                            @click="save_task"
                            href="javascript:{}"
                            :class="{
                                'btn btn-primary': true,
                                disabled: task_event_save_btn_disabled
                            }"
                        >
                            Save
                        </a>
                        <a
                            v-if="
                                $route.meta.isAddView &&
                                    $route.name === 'event-guests-add' &&
                                    user_added_persons_count &&
                                    user_added_persons_count > 0
                            "
                            @click="save_guests"
                            href="javascript:{}"
                            :class="{
                                disabled: guest_ids <= 0,
                                'btn btn-primary': true
                            }"
                        >
                            + Add selected
                        </a>
                        <a
                            v-if="
                                $route.meta.isAddView &&
                                    $route.name === 'event-guests-add' &&
                                    user_added_persons_count === 0
                            "
                            @click="go_to_add_people"
                            href="javascript:{}"
                            :class="{
                                'btn btn-primary': true
                            }"
                        >
                            + Add new
                        </a>
                        <div
                            v-if="!$route.meta.isAddView"
                            :class="{ 'drop menu-more': true, show: dropShown }"
                            v-click-outside="away"
                        >
                            <a @click="showDrop" href="javascript:{}"><span class="icon icon-dots"></span></a>
                            <div class="drop-content">
                                <ul>
                                    <li v-if="$route.name !== 'event-edit'">
                                        <a @click="go_to_edit" href="javascript:{}">Edit event</a>
                                    </li>
                                    <li>
                                        <a class="red" @click="remove_event()" href="javascript:{}">Delete event</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <event-submenu v-if="!$route.meta.isAddView"></event-submenu>
                    <div class="main-tabs" v-if="$route.name === 'event-guests-add'" style="border-top: none;">
                        <ul>
                            <li @click="change_tab('adults')" :class="{ active: active_people_tab === 'adults' }">
                                <a href="javascript:{}"
                                    >Adults<span v-if="potential_guests_adults && potential_guests_adults.length > 0">{{
                                        potential_guests_adults.length
                                    }}</span></a
                                >
                            </li>
                            <li @click="change_tab('kids')" :class="{ active: active_people_tab === 'kids' }">
                                <a href="javascript:{}"
                                    >Kids<span v-if="potential_guests_kids && potential_guests_kids.length > 0">{{
                                        potential_guests_kids.length
                                    }}</span></a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <router-view></router-view>
            <mobile-footer-menu></mobile-footer-menu>
        </div>
    </div>
</template>

<script>
import MobileFooterMenu from "./mobile-footer-menu.vue";
import MainNavigationHeader from "@/pages/main-navigation-header.vue";
import EventSubmenu from "./event-submenu.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import router from "@/router";
import vClickOutside from "v-click-outside";
import EventDeleteModal from "./delete-confirmation";
import TrialOver from "./trial-over-modal.vue";

export default {
    name: "event-layout",
    components: { EventDeleteModal, MobileFooterMenu, MainNavigationHeader, EventSubmenu, TrialOver },
    created() {},
    mounted() {
        this.get_current_event(this.$route.params.id);
        this.get_logged_in_user();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_event();
            vm.get_logged_in_user();
            next();
        });
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        ...mapState("StoreEvent", ["event", "active_people_tab", "user_added_persons_count", "event_loaded"]),
        ...mapState("StoreEvent", ["event_task", "guest_ids"]),
        ...mapState("StoreEvent", ["task_event_save_btn_disabled"]),
        ...mapState("StoreEvent", ["global_errors"]),
        ...mapState(["user"]),
        ...mapState("StoreEvent", ["event", "active_people_tab"]),
        ...mapGetters("StoreEvent", ["potential_guests_adults", "potential_guests_kids"])
    },

    watch: {
        event_task: {
            handler: function(newVal, old_val) {
                if (old_val) {
                    if (newVal.name && newVal.name.trim()) {
                        this.btn_disabled = false;
                    } else {
                        this.btn_disabled = true;
                    }
                }
            },
            deep: true
        }
    },
    data() {
        return {
            trial_modal_shown: false,
            delete_modal_shown: false,
            btn_disabled: true,
            dropShown: false,
            show_all: false
        };
    },
    methods: {
        ...mapActions(["get_logged_in_user"]),
        ...mapActions("StoreEvent", ["get_event", "invite_to_event"]),
        ...mapActions("StoreEvent", ["delete_event"]),
        ...mapActions("StoreEvent", ["save_event_task"]),
        ...mapMutations("StoreEvent", ["clear_event", "clear_task_event", "set_active_people_tab", "set_event_state"]),
        away() {
            if (this.dropShown) {
                this.dropShown = false;
            }
        },
        show_delete_modal() {
            this.delete_modal_shown = true;
        },
        hide_delete_modal() {
            this.delete_modal_shown = false;
        },
        get_current_event(event_id) {
            this.set_event_state(false);
            this.get_event(event_id);
        },
        set_empty_event() {
            this.clear_event();
        },
        go_to_add_people() {
            router.push({ path: "/people/add" });
        },
        save_task() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.save_event_task(this.event_task);
            } else {
                this.trial_modal_shown = true;
            }
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },

        showDrop() {
            this.dropShown = !this.dropShown;
        },
        go_back() {
            if (this.$route.name === "events-tasks-add") {
                router.push({ path: "/events/" + this.event.id });
            } else if (this.$route.name === "event-guests-add") {
                router.push({ path: "/events/" + this.event.id });
            } else if (this.$route.name === "event") {
                router.push({ path: "/events" });
            } else if (this.$route.name === "event-guests") {
                router.push({ path: "/events/" + this.event.id });
            } else {
                router.go(-1);
            }
        },
        save_guests() {
            this.invite_to_event(this.event.id);
        },
        change_tab(tab) {
            this.set_active_people_tab(tab);
        },
        go_to_edit() {
            this.dropShown = false;
            router.push({ path: "/events/edit/" + this.event.id });
        },
        remove_event() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.dropShown = false;
                if (this.event.recurring && this.event.recurring !== "never") {
                    this.show_all = true;
                    this.show_delete_modal();
                } else {
                    this.show_all = false;
                    this.show_delete_modal();
                }
            } else {
                this.dropShown = false;
                this.trial_modal_shown = true;
            }
        }
    }
};
</script>

<style scoped>
.drop {
    flex: initial;
    width: initial;
}

.is-edit .main-nav-left p {
    margin-bottom: 1.4rem;
}
</style>
